import React from "react";
import PropTypes from "prop-types";

const SkeletonBox = ({ count, width, height, bgColor }) => {
  const renderSkeletonBox = () => {
    const result = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < count; i++) {
      result.push(
        <span
          key={i}
          className="skeleton-box"
          style={{ width, height, marginTop: "15px", backgroundColor: bgColor }}
        />
      );
    }
    return result;
  };

  return <>{renderSkeletonBox()}</>;
};

SkeletonBox.propTypes = {
  count: PropTypes.number,
  width: PropTypes.string,
  height: PropTypes.string,
  bgColor: PropTypes.string,
};

SkeletonBox.defaultProps = {
  count: 1,
  width: "auto",
  height: "20px",
  bgColor: "none",
};

export default SkeletonBox;
